"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class SessionController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            list: '/v1/admin/session',
            listUser: '/v1/admin/session/:userId',
            delete: '/v1/admin/session/:objectId',
        };
    }
    listSessions() {
        return this.manager.get({
            url: this.endpoints.list,
        });
    }
    listUserSessions(userId) {
        return this.manager.get({
            url: this.endpoints.listUser,
            params: { userId },
        });
    }
}
exports.default = SessionController;
